export default "__VITE_ASSET__CUJYbieI__"